import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.prescriptions');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-prescriptions',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.prescriptions/view.scss */
:host {
  display: block;
  height: 100%;
}

.prescription-shell {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  background: #f3f6f9;
}

.prescription-header {
  gap: 12px;
  padding: 10px 14px;
  border-bottom-color: #cfd8e3;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
}

.prescription-header-main {
  min-width: 0;
  flex: 1;
}

.prescription-header-kicker,
.prescription-panel-kicker,
.prescription-side-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.prescription-header-title-row {
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.prescription-header-title {
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
}

.prescription-header-meta {
  font-size: 11px;
  color: #64748b;
}

.prescription-header-sub {
  margin-top: 2px;
  font-size: 11px;
  color: #64748b;
}

.prescription-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.prescription-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 12px 14px 16px;
}

.prescription-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 12px;
  min-height: 100%;
}

.prescription-main-panel,
.prescription-side-panel {
  min-width: 0;
}

.prescription-side-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.prescription-census-strip,
.prescription-list-panel,
.prescription-side-card {
  border: 1px solid #d8e1eb;
  background: #ffffff;
}

.prescription-census-strip {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  margin-bottom: 10px;
}

.prescription-census-cell {
  padding: 10px 12px;
  border-right: 1px solid #e2e8f0;
  border-top: 3px solid #cbd5e1;
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s;
  cursor: pointer;
}
.prescription-census-cell:last-child {
  border-right: 0;
}
.prescription-census-cell:hover {
  background: #f8fafc;
}

.prescription-census-cell--emerald {
  border-top-color: #10b981;
}

.prescription-census-cell--amber {
  border-top-color: #f59e0b;
}

.prescription-census-cell--green {
  border-top-color: #16a34a;
}

.prescription-census-cell--blue {
  border-top-color: #3b82f6;
}

.prescription-census-cell--rose {
  border-top-color: #e11d48;
}

.prescription-census-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.prescription-census-value {
  display: block;
  margin-top: 4px;
  font-size: 22px;
  line-height: 1;
  font-weight: 800;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.prescription-census-sub {
  display: block;
  margin-top: 4px;
  font-size: 10px;
  color: #94a3b8;
}

.prescription-list-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.prescription-panel-title {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

.prescription-panel-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 10px;
  color: #64748b;
}

.prescription-filter-strip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  overflow: auto;
}

.prescription-table-wrap {
  overflow: auto;
}

.prescription-table th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.prescription-table-row {
  cursor: pointer;
}
.prescription-table-row:hover {
  background: #f8fafc;
}

.prescription-name-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.prescription-name {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
}

.prescription-lead {
  font-size: 10px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 240px;
}

.prescription-empty-state {
  padding: 48px 24px;
  text-align: center;
}

.prescription-empty-title {
  font-size: 14px;
  font-weight: 700;
  color: #475569;
}

.prescription-empty-sub {
  margin-top: 6px;
  font-size: 11px;
  color: #94a3b8;
}

.prescription-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 12px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

.prescription-side-card {
  padding: 10px 12px;
}

.prescription-snapshot-row,
.prescription-mini-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #eef2f7;
  text-align: left;
  transition: color 0.15s;
  cursor: pointer;
}
.prescription-snapshot-row:last-child,
.prescription-mini-row:last-child {
  border-bottom: 0;
}
.prescription-snapshot-row:hover,
.prescription-mini-row:hover {
  color: #0f172a;
}

.prescription-snapshot-row span,
.prescription-snapshot-row strong {
  font-size: 11px;
}

.prescription-snapshot-row span {
  color: #475569;
}

.prescription-snapshot-row strong {
  font-weight: 800;
  color: #0f172a;
}

.prescription-mini-main {
  min-width: 0;
  flex: 1;
}

.prescription-mini-name {
  font-size: 11px;
  font-weight: 700;
  color: #0f172a;
}

.prescription-mini-meta {
  margin-top: 2px;
  font-size: 10px;
  color: #64748b;
}

.prescription-mini-action {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  white-space: nowrap;
}

@media (max-width: 1279px) {
  .prescription-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .prescription-census-strip {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 767px) {
  .prescription-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .prescription-header-actions {
    width: 100%;
  }
  .prescription-census-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .prescription-filter-strip {
    flex-wrap: wrap;
  }
}`],
})
export class PagePrescriptionsComponent implements OnInit {
    public prescriptions: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public searchText: string = '';
    public typeFilter: string = '';
    public statusFilter: string = '';

    public showDetail: boolean = false;
    public selectedPresc: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
        await this.service.render();
    }

    public async load(page: number = 1) {
        this.page = page;
        const { code, data } = await wiz.call('search', {
            text: this.searchText, page: this.page, dump: this.dump,
            prescription_type: this.typeFilter,
            status: this.statusFilter
        });
        if (code === 200) {
            this.prescriptions = data.rows || [];
            this.total = data.total || 0;
        }
        await this.service.render();
    }

    public get totalPages() { return Math.ceil(this.total / this.dump); }
    public get pages() {
        const arr = [];
        const s = Math.max(1, this.page - 2);
        const e = Math.min(this.totalPages, s + 4);
        for (let i = s; i <= e; i++) arr.push(i);
        return arr;
    }

    public confirmedCount() {
        return this.prescriptions.filter((prescription: any) => prescription.status === 'confirmed').length;
    }

    public draftCount() {
        return this.prescriptions.filter((prescription: any) => prescription.status === 'draft').length;
    }

    public cancelledCount() {
        return this.prescriptions.filter((prescription: any) => prescription.status === 'cancelled').length;
    }

    public typeCount(type: string) {
        return this.prescriptions.filter((prescription: any) => prescription.prescription_type === type).length;
    }

    public getPrescriptionStatusClass(status: string) {
        const map: any = {
            draft: 'bg-amber-100 text-amber-700',
            confirmed: 'bg-emerald-100 text-emerald-700',
            cancelled: 'bg-rose-100 text-rose-700',
        };
        return map[status] || 'bg-slate-100 text-slate-600';
    }

    public getPrescriptionCardClass(presc: any) {
        if (presc.status === 'cancelled') return 'border-rose-200 bg-rose-50/80';
        if (presc.status === 'draft') return 'border-amber-200 bg-white';
        if (presc.prescription_type === 'herbal') return 'border-emerald-200 bg-white';
        if (presc.prescription_type === 'acupuncture') return 'border-sky-200 bg-white';
        return 'border-slate-200 bg-white';
    }

    public getPrescriptionLead(presc: any) {
        if (presc.instructions) return presc.instructions;
        if (presc.total_days) return `${presc.total_days}일 복용 · 1일 ${presc.daily_doses || 3}회`;
        return '상세 화면에서 약재 구성과 복약 지도를 확인할 수 있습니다.';
    }

    public recentPrescriptions(limit: number = 5) {
        return this.prescriptions.slice(0, limit);
    }

    public activeFilterLabel() {
        const parts: string[] = [];
        if (this.typeFilter) parts.push(this.getTypeLabel(this.typeFilter));
        if (this.statusFilter) parts.push(this.getStatusLabel(this.statusFilter));
        if (this.searchText.trim()) parts.push(`검색: ${this.searchText.trim()}`);
        if (parts.length === 0) return '전체 처방 이력';
        return parts.join(' · ');
    }

    public async applyStatusFilter(status: string) {
        this.statusFilter = status;
        await this.load(1);
    }

    public async applyTypeFilter(type: string) {
        this.typeFilter = type;
        await this.load(1);
    }

    public async clearFilters() {
        this.searchText = '';
        this.typeFilter = '';
        this.statusFilter = '';
        await this.load(1);
    }

    public async openDetail(presc: any) {
        const { code, data } = await wiz.call('detail', { id: presc.id });
        if (code === 200) {
            this.selectedPresc = data;
            if (typeof this.selectedPresc.herbs === 'string') {
                try { this.selectedPresc.herbs = JSON.parse(this.selectedPresc.herbs); } catch { this.selectedPresc.herbs = []; }
            }
            if (typeof this.selectedPresc.acupoints === 'string') {
                try { this.selectedPresc.acupoints = JSON.parse(this.selectedPresc.acupoints); } catch { this.selectedPresc.acupoints = []; }
            }
            this.showDetail = true;
            await this.service.render();
        }
    }

    public closeDetail() { this.showDetail = false; this.service.render(); }

    public openChart(presc: any) {
        if (!presc?.visit_id) return;
        this.service.href(`/chart/${presc.visit_id}`);
    }

    public getTypeLabel(t: string) {
        const map: any = { herbal: '한약', acupuncture: '침', cupping: '부항', moxa: '뜸', chuna: '추나', other: '기타' };
        return map[t] || t;
    }

    public getTypeClass(t: string) {
        const map: any = {
            herbal: 'bg-green-100 text-green-700',
            acupuncture: 'bg-blue-100 text-blue-700',
            cupping: 'bg-purple-100 text-purple-700',
            moxa: 'bg-orange-100 text-orange-700',
            chuna: 'bg-teal-100 text-teal-700'
        };
        return map[t] || 'bg-gray-100 text-gray-700';
    }

    public getRoleLabel(r: string) {
        const map: any = { '군': '君(군)', '신': '臣(신)', '좌': '佐(좌)', '사': '使(사)' };
        return map[r] || r;
    }

    public getStatusLabel(s: string) {
        const map: any = { draft: '작성중', confirmed: '확정', cancelled: '취소' };
        return map[s] || s;
    }
}

export default PagePrescriptionsComponent;